import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export default function updateBossHighlightReducer(state: Partial<any> = {}, action: TAction<any>): any {
  switch (action.type) {
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default:
      return state;
  }
}
